import { render } from "./B2bFilterButtonServicios.vue?vue&type=template&id=756dd53e&scoped=true&lang=pug"
import script from "./B2bFilterButtonServicios.vue?vue&type=script&lang=js"
export * from "./B2bFilterButtonServicios.vue?vue&type=script&lang=js"

import "./B2bFilterButtonServicios.vue?vue&type=style&index=0&id=756dd53e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-756dd53e"]])

export default __exports__